module.exports = __webpack_public_path__ + "img/equ04.301ac04f.jpg";